import { ILeadFormModel } from '@user/components/Leads/AddLeadForm/typings'
import { entityNextActionDate } from '@user/components/Settings/EntityFormSettings/constants'
import { selectAllEntityFormSettings } from '@user/store/entityFormSettings'
import { useGetFieldActiveStates } from '@user/store/entityFormSettings/hooks/useGetFieldActiveStates'
import { getIn, useFormikContext } from 'formik'
import { useSelector } from 'react-redux'

type Props = {
  fieldName: string
  hideOptional: boolean
}

export function useData(props: Props) {
  const { fieldName, hideOptional } = props

  const settings = useSelector(selectAllEntityFormSettings)
  const entitySettingsMap = useGetFieldActiveStates(settings, hideOptional)

  const [requiredNextActionDate, showNextActionDate] = entitySettingsMap.get(
    entityNextActionDate,
  ) ?? [false, true]

  const { errors, touched } = useFormikContext<ILeadFormModel>()

  const errorText: string | undefined =
    touched[fieldName] == true && errors[fieldName]
      ? getIn(errors, fieldName)
      : undefined

  const hasError = !!errorText

  return { errorText, hasError, requiredNextActionDate, showNextActionDate }
}
